// Date/label formatters for the Tender Opening module — Jakarta (GMT+07:00).
//
// Unlike the shared Planning/ProcurementValidity formatters (which render UTC
// on purpose, see ../formatters.js), Tender Opening renders every datetime in
// Jakarta time per rule §Catatan 1. Kept as a separate module-local file so
// this choice doesn't leak into Planning/Procurement, which still rely on the
// UTC echo-back behaviour documented there.
//
// Write-path (sending a value back to the BE) still goes through ISO 8601 —
// see toIsoDateTime below — that part lands with the Edit page (a later task).

const JAKARTA_TZ = 'Asia/Jakarta';

// "05 Jan 2026, 08:30" — used in list/detail columns.
export const formatDateTime = value => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: JAKARTA_TZ,
  });
};

// "05 Jan 2026" — date only.
export const formatDate = value => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: JAKARTA_TZ,
  });
};

// "Aug 2026" — month picker display for contract periods.
export const formatMonth = value => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('en-GB', {
    month: 'short',
    year: 'numeric',
    timeZone: JAKARTA_TZ,
  });
};

// Convert a Date (or ISO string) to an ISO 8601 string for sending back to the
// BE (contract endpoints 3/4/9 — a later, Edit-page task; kept here so the
// write-side conversion lives next to the read-side formatters it mirrors).
export const toIsoDateTime = value => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
};
